import { Navigate, Route, Routes, useParams } from "react-router-dom";
import { AppShell } from "./shell/AppShell";
import { HomePage } from "./pages/HomePage";
import { PlansPage } from "./pages/PlansPage";
import { MarketsPage } from "./pages/MarketsPage";
import { BlockPage } from "./pages/BlockPage";
import { RuleFormPage } from "./pages/RuleFormPage";
import { WelcomePage } from "./pages/WelcomePage";
import { StoresPage } from "./pages/StoresPage";
import { SettingsPage } from "./pages/SettingsPage";
import { PopupPage } from "./pages/PopupPage";
import { HelpPage } from "./pages/HelpPage";

/** Legacy /app/rules/:id → store or block form once kind known (form loads rule). */
function LegacyRuleEditRedirect() {
  const { id } = useParams();
  return <Navigate to={`/app/stores/${id}`} replace />;
}

/**
 * SafeGeo Admin SPA - nav IA from version5 Dev Spec §3
 * (Market / Store / Block separate · Plan + Help on menu).
 */
export function App() {
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<HomePage />} />
        <Route path="app" element={<HomePage />} />
        <Route path="app/welcome" element={<WelcomePage />} />
        {/* First-pick funnel uses /app/plans (nav hidden). Returning: /app/billing. */}
        <Route path="app/plans" element={<PlansPage />} />
        <Route path="app/plan" element={<PlansPage />} />
        <Route path="app/billing" element={<PlansPage />} />

        {/* v5: three separate redirect surfaces */}
        <Route path="app/market" element={<MarketsPage />} />
        <Route path="app/markets" element={<MarketsPage />} />
        <Route path="app/stores" element={<StoresPage />} />
        <Route path="app/stores/new" element={<RuleFormPage />} />
        <Route path="app/stores/:id" element={<RuleFormPage />} />
        <Route path="app/block" element={<BlockPage />} />
        <Route path="app/block/new" element={<RuleFormPage />} />
        <Route path="app/block/:id" element={<RuleFormPage />} />

        {/* Legacy unified Redirects / Countries → Market */}
        <Route
          path="app/redirects"
          element={<Navigate to="/app/market" replace />}
        />
        <Route
          path="app/rules"
          element={<Navigate to="/app/market" replace />}
        />
        <Route
          path="app/rules/new"
          element={<Navigate to="/app/stores/new" replace />}
        />
        <Route path="app/rules/:id" element={<LegacyRuleEditRedirect />} />

        <Route path="app/settings" element={<SettingsPage />} />
        <Route path="app/popup" element={<PopupPage />} />
        <Route
          path="app/design"
          element={<Navigate to="/app/popup" replace />}
        />
        <Route path="app/help" element={<HelpPage />} />
        <Route path="*" element={<Navigate to="/app" replace />} />
      </Route>
    </Routes>
  );
}
